import { useSelector } from 'react-redux'
import { Card, CardBody, TrackScrolledIntoView } from '@homebotapp/hb-react-component-catalog'
import { RefiByYearsInHome } from './RefiByYearsInHome'
import { HOMEOWNER_DIGEST_REFI_MODULE } from '../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'
import { REFINANCE_OPTIONS } from '../../../constants/document_ids'
import { NegativeRefiInfo } from './NegativeRefiInfo/NegativeRefiInfo'
import { selectShouldRenderNegativeRefiOptionInfoMessage } from '../../../store/selectors/display'

export interface RefiModuleProps {
  withCurrentHomeData: boolean
}

export const RefiModule = ({ withCurrentHomeData }: RefiModuleProps) => {
  const showNegativeRefiInfo = useSelector(selectShouldRenderNegativeRefiOptionInfoMessage)

  return (
    <TrackScrolledIntoView
      tracking={{
        guid: 'rsvCz1VcTKRZEhZJFDvdBq',
        ui_context: HOMEOWNER_DIGEST_REFI_MODULE,
        descriptor: 'Refi Module scrolled into view'
      }}
    >
      <Card size='lg' id={REFINANCE_OPTIONS} scrollMarginTop='var(--digest-module-scroll-margin-top)'>
        <CardBody paddingX={[2, null, 7]}>
          <RefiByYearsInHome withCurrentHomeData={withCurrentHomeData} />
          {showNegativeRefiInfo && (
            <>
              <hr />
              <NegativeRefiInfo />
            </>
          )}
        </CardBody>
      </Card>
    </TrackScrolledIntoView>
  )
}
